import { Route } from 'react-router';
import PublicRoute from './PublicRoute'
import DetailLayout from '../contexts/shared/components/layouts/DetailLayout'
import EventDetail from '../contexts/backoffice/events/ui/pages/EventDetail'
import SeminarDetail from '../contexts/backoffice/seminars/ui/pages/SeminarDetail'
import NewsDetail from '../contexts/backoffice/news/ui/pages/NewsDetail'
import NoveltyDetail from '../contexts/backoffice/novelties/ui/pages/NoveltyDetail'
import OfferDetail from '../contexts/frontoffice/offers/ui/pages/OfferDetail'
import ResourceDetail from '../contexts/backoffice/library/ui/pages/ResourceDetail'
import CourseDetail from '../contexts/backoffice/courses/ui/pages/CourseDetail'

export const DetailRoutes = (
  <Route path="/" element={<PublicRoute><DetailLayout /></PublicRoute>}>
    <Route path="biblioteca/:id" element={<ResourceDetail />} />
    <Route path="eventos/:id" element={<EventDetail />} />
    <Route path="seminarios/:id" element={<SeminarDetail />} />
    <Route path="cursos/:brandId/:slug" element={<CourseDetail />} />
    <Route path="noticias/:slug" element={<NewsDetail />} />
    <Route path="novedades/:slug" element={<NoveltyDetail />} />
    <Route path="ofertas/:id" element={<OfferDetail />} />
  </Route>
);
